export default "__VITE_ASSET__C4YmVnxf__"